import { useState } from "react";
import style from "./ProxySettings.module.scss";
import cn from "classnames";
import { Funds, Term } from "./components";

export function ProxySettings({
    term,
    funds,
    isOpen
}: { 
    term?: boolean, 
    funds?: boolean,
    isOpen: boolean
}) {
    const [activeTab, setActiveTab] = useState<"term" | "funds">("term")

    return (
        <div className={style.container}>
            <div className={style.tabsNavigate}>
                {term && <button
                    className={cn(style.button, activeTab === "term" && style.button_active)}
                    onClick={() => setActiveTab("term")}>
                    Термін
                </button>}
                {funds && <button
                    className={cn(style.button, activeTab === "funds" && style.button_active)}
                    onClick={() => setActiveTab("funds")}>
                    Кошти
                </button>}
            </div>
            {
                isOpen ?
                    <>
                        {
                            activeTab === "term"
                                ? <Term  />
                                : null
                        }
                        {
                            activeTab === "funds"
                                ? <Funds />
                                : null
                        }
                    </>
                    : null
            }
        </div>
    )
}